<template>
    <div style="position: relative;height: 100%;">
        <div class="text-book" style="margin-top: 10px;">
            <div class="title">单词基础</div>
            <div class="title-text">智能复习以德国心理学家赫尔曼·艾宾浩斯(Hermann Ebbinghaus)的遗忘曲线为理论基础，辅助记忆。</div>
        </div>
        <div class="right-img">
            <img src="../../assets/img/jiyi.png" alt="">
        </div>
        <div class="location-box">
            <div class="btn-box">
                <el-button type="primary" @click="startReview">智能复习</el-button>
            </div>
            <div class="hint-text">
                <span>你约有<span style="color: #fe7e4a;font-size: 25px;">{{learnData.count}}</span>个单词需要复习</span>
            </div>
        </div>
        <dynamic-box
                :windowStatus="windowStatus"
                :data="wordStudyStage.dataSource"
                :type="wordStudyStage.type"
                @callBack="callBack">
        </dynamic-box>
    </div>
</template>

<script>
    import {mapGetters, mapMutations} from 'vuex';
    import {AIintelligentReview} from '../../api/words'
    import dynamicBox from "./templates/dynamicBox";
    import Lockr from "lockr";

    export default {
        name: "smartReview",
        computed: {
            ...mapGetters(['wordStudyStage'])
        },
        components: {dynamicBox},
        data() {
            return {
                windowStatus: false,
                learnData: '',//获取智能复习资料
            }
        },
        methods: {
            ...mapMutations(['CHANGE_WORD_STUDY_TYPE']),
            // 智能复习
            startReview() {
                let res = this.learnData
                let data = {
                    title: '智能复习',
                    type: 'AiStudy/spell',
                    dataSource: res,
                    courseType: 'znfx',//智能复习
                }
                this.CHANGE_WORD_STUDY_TYPE(data)
                this.windowStatus = true
            },
            // 关闭语音识别
            clickedVoicePop() {
                this.ShowVoicePop = false;
            },
            //获取需要智能复习的单词数量
            getWordNum() {
                //精准复习
                let params = {
                    token: Lockr.get('token'),
                    sign: 5,
                }
                AIintelligentReview(params).then(res => {
                    this.learnData = res.data
                })
            },
            // 动态组件回调
            callBack(data) {
                if (data.type == 'close') {
                    this.windowStatus = false;
                }
            },
        },
        created() {
            this.getWordNum()
        },
    }
</script>

<style scoped lang='less'>
    .text-book {
        flex: 1;
        background: #fff;

        .title {
            display: flex;
            align-items: center;
            font-size: 20px;
            font-weight: bold;
            padding-left: 10px;
            border-left: 3px solid #333;
        }

        .title-text {
            border: 2px solid #F5A623;
            padding: 10px 20px;
            margin: 20px 15px;
            font-size: 14px;
            font-weight: bold;
            color: #333;
            line-height: 19px;
        }
    }

    .right-img {
        width: 495px;
        min-height: 350px;
        margin: 0 auto;

        img {
            width: 495px;
            height: 350px;
        }

    }

    .location-box {
        /*position: absolute;*/
        /*bottom: 15px;*/
        /*right: 0;*/
        /*width: 100%;*/

        .btn-box {
            border-bottom: 1px dashed #999;
            text-align: right;
            padding: 20px 30px;
        }

        .hint-text {
            font-size: 18px;
            text-align: right;
            padding: 15px 17px;

            span {
                padding: 0 6px;
            }
        }
    }

</style>